// Subscription type constants - must match backend lowercase values
export const SUBSCRIPTION_TYPES = {
  FREE: "free",
  PAY_AS_YOU_GO: "pay-as-you-go",
  ENTREPRENEUR: "entrepreneur",
  BUSINESS: "business",
  ENTERPRISE: "enterprise",
} as const;

// Type for subscription types
export type SubscriptionType =
  (typeof SUBSCRIPTION_TYPES)[keyof typeof SUBSCRIPTION_TYPES];

// Display names for subscription types (for UI)
export const SUBSCRIPTION_DISPLAY_NAMES = {
  [SUBSCRIPTION_TYPES.FREE]: "Free",
  [SUBSCRIPTION_TYPES.PAY_AS_YOU_GO]: "Pay As You Go",
  [SUBSCRIPTION_TYPES.ENTREPRENEUR]: "Entrepreneur",
  [SUBSCRIPTION_TYPES.BUSINESS]: "Business",
  [SUBSCRIPTION_TYPES.ENTERPRISE]: "Enterprise",
} as const;

// Plan groupings for feature access
export const PAID_PLANS = [
  SUBSCRIPTION_TYPES.PAY_AS_YOU_GO,
  SUBSCRIPTION_TYPES.ENTREPRENEUR,
  SUBSCRIPTION_TYPES.BUSINESS,
  SUBSCRIPTION_TYPES.ENTERPRISE,
] as const;

// Premium plans = all paid plans (Pay As You Go, ENTREPRENEUR, Business, Enterprise)
// This grants access to all non-free features
export const PREMIUM_PLANS = [
  SUBSCRIPTION_TYPES.PAY_AS_YOU_GO,
  SUBSCRIPTION_TYPES.ENTREPRENEUR,
  SUBSCRIPTION_TYPES.BUSINESS,
  SUBSCRIPTION_TYPES.ENTERPRISE,
] as const;
